import React, { useEffect } from 'react'

import { Col } from 'react-bootstrap'

const CountryCurrencyPerMonth = ({ country }) => {
    useEffect(() => {

    }, [country])
    return <Col lg={12} className="pl-1 mt-2"><p className="extra-text">{country.currency} / Month</p></Col>
}

export default CountryCurrencyPerMonth